// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React, { useMemo, useEffect, useState } from 'react'
import { GeoJSONLayer,Popup} from 'react-mapbox-gl'
import {Card, message} from 'antd'
import { CopyOutlined } from '@ant-design/icons'
import Clipboard from 'clipboard'
import './trace.less'
import moment from 'moment'
import * as turf from '@turf/turf'

const formatGridToGeoJson = (traces = []) => {
  const paths = traces.map(x => ({
    type: 'Feature',
    properties: {
      color: '#000',
      width: 1,
    },
    geometry: {
      type: 'LineString',
      coordinates: x.map(trace => [trace.lon, trace.lat]),
    }
  }))
  return {
    type: 'FeatureCollection',
    features: [...paths]
  }
}

const formatTraceToGeoJson = (traces = []) => {
  const paths = traces.map(x => ({
    type: 'Feature',
    properties: {
      color: '#136FD8',
      width: 8,
    },
    geometry: {
      type: 'LineString',
      coordinates: x.map(trace => [trace.lon, trace.lat]),
    }
  }))
  return {
    type: 'FeatureCollection',
    features: [...paths]
  }
}


const GPSInfo = props => {
  useEffect(()=>{
    const clipboard = new Clipboard('.btn');
    clipboard.on('success',function(e){
      e.clearSelection();
      message.success('copied')
    })
    return()=>{clipboard.destroy()}
  },[])
  const {data} = props
  return (
    <Card style={{width: 280,height: 180, padding:2, marginLeft: 70}} title={'GPS info'}>
      {
        Object
          .values(data)
          .map((item,index)=>(
            <div key={index} className={'card-item'} >
              <span>{item.name == 'timestamp' ? 'utc time':item.name}:</span>
              <p className={'value'}>
                <span id={`target${index}`}>{item.value}</span>
              </p>
              <span className={'btn value'} style={{cursor: 'pointer'}} data-clipboard-target={`#target${index}`}><CopyOutlined /></span>
            </div>
          ))
      }
    </Card>
  )
}

const colorChoice = trace => {
  if (trace.workStatus == 4) {
    return '#51d6ac'
  }
  if (trace.workStatus == 12) {
    return '#aeaeae'
  }
  if (trace.chargingStatus == 1) {
    return '#edd72f'
  }
  return '#aeaeae'
}

const StatusTraces = props => {
  const [hoveredPoint,setHoveredPoint] = useState(null)
  const { statusTraces=[], gridPoints=[], map } = props
    // currentTrace
  const isHidden = !statusTraces.length
  const geoJSON = useMemo(()=>formatGridToGeoJson(gridPoints),[gridPoints])

  const statusesJSON = useMemo(()=>({
  type: 'FeatureCollection',
  features: statusTraces
    .flat()
    //.filter((item, index)=> item.workStatus == 4)
    .map((trace,index) => ({
      type: 'Feature',
      properties: {
        ...trace,
        id: index,
        width: 3,
        color: colorChoice(trace),
      },
        geometry: {
        type: 'Point',
        coordinates: [trace.lon, trace.lat],
      }
  }))}),[statusTraces])

  return (
    <>
        <GeoJSONLayer
          id={'grid'}
          lineLayout={{
            visibility: gridPoints.length === 0 ? 'none' : 'visible'
          }}
          linePaint={{
            'line-width': ['get', 'width'],
            'line-color': ['get', 'color'],
          }}
          data={geoJSON}
        />
      <GeoJSONLayer
        id={ 'statusPoint'}
        circleLayout={{
          'visibility': isHidden ? 'none' : 'visible'
        }}
        // sourceOptions={{
        //   type:'geojson',
        //   cluster: false,
        //   clusterMaxZoom: 20, // Max zoom to cluster points on
        //   clusterRadius: 10,
        //   clusterProperties:{
        //     // "timestamp": ["max", ["get", "timestamp"]],
        //   },
        //   'generateId': true
        // }}
        circlePaint={{
          "circle-stroke-width": 1,
          // "circle-stroke-width": ['case', ['boolean', ['feature-state', 'hover'], false], 1, 0],
          "circle-stroke-color": ['get', 'color'],
          // "circle-opacity": ['case', ['boolean', ['feature-state', 'hover'], false], 1, 0],
          //'circle-color': '#51d6ac',
          'circle-color': ['get', 'color'],
          'circle-radius': ['get', 'width'],
        }}
        data={statusesJSON}
      />
    </>
  )
}


const Traces = props => {
  const [hoveredPoint,setHoveredPoint] = useState(null)
  const { traces=[],map } = props
  useEffect(()=>{
      map && map.on('click',clickHandler)
    return()=>{
        map && map.off('click',clickHandler)
    }
  },[map,hoveredPoint,traces] )
    // currentTrace
  const isHidden = !traces.length
  const geoJSON = useMemo(()=>formatTraceToGeoJson(traces),[traces])
  // const pointsJSON = useMemo(()=>({
  //     type: 'FeatureCollection',
  //     features: traces
  //       .flat()
  //       // .filter((item, index)=> index < 10000)
  //       .map((trace,index) => ({
  //         type: 'Feature',
  //         // properties: {
  //         //   ...trace,
  //         //   id: index,
  //         //   width: 10,
  //         //   color: '#51bbd6',
  //         // },
  //         geometry: {
  //           type: 'Point',
  //           coordinates: [trace.lon, trace.lat],
  //         }
  //       }))}),[traces])
  const points = useMemo(()=>{
    return turf.featureCollection(
      traces
        .flat()
        .map(item=>turf.point([item.lon,item.lat],{...item}))
    )
  },[traces])
  // traces.length && document.write(JSON.stringify(geoJSON))
  const clickHandler = (event)=>{
    const features = map.queryRenderedFeatures(event.point,{layers:['trace-line']});
    if(features.length==0){
      setHoveredPoint(null)
      return
    }
    const targetPoint = turf.point([event.lngLat.lng,event.lngLat.lat])
    const targetFeature = turf.nearestPoint(targetPoint,points)
    setHoveredPoint(targetFeature)
    // let newHoveredPoint;
    // const features = map?.queryRenderedFeatures(event.point,{layers:['gpspoint-circle']});
    // if(features.length === 0) {
    //   hoveredPoint?.id && map.setFeatureState({source:'gpspoint',id:hoveredPoint.id},{hover: false})
    //   setHoveredPoint(null)
    //   return;
    // }
    // const targetFeature =  features[0]
    // const {cluster_id: clusterID,cluster,...rest} =  targetFeature?.properties || {}
    // console.log('event===',event, targetFeature,clusterID, rest, hoveredPoint,features)
    // if(!cluster) {
    //   newHoveredPoint = rest
    //   newHoveredPoint.id = targetFeature?.id
    //   if(hoveredPoint?.id === newHoveredPoint.id) return
    //   console.log('event===1',newHoveredPoint,hoveredPoint)
    //   hoveredPoint?.id && map.setFeatureState({source:'gpspoint',id: hoveredPoint.id},{hover: false})
    //   newHoveredPoint?.id && map.setFeatureState({source:'gpspoint',id: newHoveredPoint.id},{hover: true})
    //   setHoveredPoint(newHoveredPoint)
    //   return
    // }
    // map
    //   .getSource('gpspoint')
    //   .getClusterLeaves(clusterID,1,0,(error, leaveFeatures) =>{
    //     if (!error) {
    //       newHoveredPoint =  leaveFeatures[0]?.properties
    //       newHoveredPoint.id = clusterID
    //       console.log('event===2',hoveredPoint,newHoveredPoint,leaveFeatures)
    //       if(hoveredPoint?.id === newHoveredPoint.id) return
    //       console.log('Cluster children:', features,hoveredPoint, newHoveredPoint);
    //
    //       newHoveredPoint?.id && map.setFeatureState({source:'gpspoint',id: newHoveredPoint.id},{hover: true})
    //       hoveredPoint?.id && map.setFeatureState({source:'gpspoint',id:hoveredPoint.id},{hover: false})
    //       setHoveredPoint(newHoveredPoint)
    //     }
    //   })

  }

  const getGPSInfoData = (data) => {
    if(!data) return []
    const newData = [
      {name:'lon',value:'',format: null},
      {name: 'lat',value:'',format:null},
      {name:'timestamp',value:'',format:(timestamp)=>moment(timestamp*1000).format('YYYY-MM-DD HH:mm:ss')}
    ]
    Object
      .values(newData)
      .forEach(item=>{
        item.value = data[item.name]
      })
    return newData
  }
  const gpsInfoData = getGPSInfoData(hoveredPoint?.properties)
  return (
      <>
        <GeoJSONLayer
          id={'trace'}
          lineLayout={{
            visibility: isHidden ? 'none' : 'visible'
          }}
          linePaint={{
            'line-width': ['get', 'width'],
            'line-color': ['get', 'color'],
          }}
          data={geoJSON}
        />
        <GeoJSONLayer
          id={ 'gpspoint'}
          circleLayout={{
            'visibility': hoveredPoint ? 'visible' : 'none',
          }}
          // sourceOptions={{
          //   type:'geojson',
          //   cluster: false,
          //   clusterMaxZoom: 20, // Max zoom to cluster points on
          //   clusterRadius: 10,
          //   clusterProperties:{
          //     // "timestamp": ["max", ["get", "timestamp"]],
          //   },
          //   'generateId': true
          // }}
          circlePaint={{
            "circle-stroke-width": 1,
            // "circle-stroke-width": ['case', ['boolean', ['feature-state', 'hover'], false], 1, 0],
            "circle-stroke-color": "#000",
            // "circle-opacity": ['case', ['boolean', ['feature-state', 'hover'], false], 1, 0],
            'circle-color': '#FFF',
            'circle-radius': 10
          }}
          data={hoveredPoint}
        />
        {
          hoveredPoint && (
            <div style={{position: 'fixed',top: 60,left: 0}}>
              <GPSInfo data={gpsInfoData}/>
            </div>
          )
        }
      </>
    )
}
export {
  Traces,
  StatusTraces
}
